module.exports = __webpack_public_path__ + "static/media/Technicalissue.a39c2132.svg";